import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators, FormArray } from '@angular/forms';
import { Quotation } from 'app/shared/types/quotation';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { QuotationService } from 'app/shared/services/quotation.service';
import { ItemService } from 'app/shared/services/item.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith, isEmpty} from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from "html-to-pdfmake"
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.css']
})
export class QuotationComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;
  checkData :any;
  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

 
  quotation: Quotation;
  quotationData = [];
  quotationForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isHideBtn: boolean= false;
  isShowAttachBtn: boolean=false;
  isBtnDisabled : boolean= false;
  isCancelBtnDisabled : boolean= false;
  isCreateInvoiceBtnDisabled : boolean= true;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  companyData : any  = [];
  logo :any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  validationMessages = {
    'quotationNo': { 'required': 'Quotation number is required' },
    'quotationDate': { 'required': 'Quotation  date is required' },
    'cusName': {'required': 'Customer is required' },
    'address': {'required': 'Address is required' },
  };

  formErrors = {
    'quotationNo': "",
    'quotationDate': "",
    'cusName': "",
    'address': "",
  };

  


  constructor(private fb: FormBuilder,
        private quotationService: QuotationService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private fileUploadService:FileUploadService,
        private itemService : ItemService,
        private route : ActivatedRoute,
        private router : Router, 
        private companyProfileService: CompanyProfileService,
        private themeService: NbThemeService,
        private decimalPipe: DecimalPipe )
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });
      }

  ngOnInit() {

   
      this.initInvoceType();
      this.initFormFields();
      this.getCompanyDetails();

      this.getItemList();
      this.getControlPermissions();
  
      this.isBtnDisabled = true;
      this.isCancelBtnDisabled = true;
     
     
      this.disableForm();
      this.viewQuotationById();
      this.quotationForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.quotationForm);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

  }// end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='QUO'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;
                this. loadLogo();            

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }

  
  autoComplete(index: number){
    this.filteredOptions[index] =this.getInvoiceItems.at(index).get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }



  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  

  getItemData(i){
    var filteredData;
    var value  = this.getInvoiceItems.at(i).get('itemCode').value;
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
      this.getInvoiceItems.at(i).patchValue({ 
        description : filteredData[0].Description,
        unitPrice:  filteredData[0].UnitPrice,
        qty :'1.00', 
        discount: '',
        amount : filteredData[0].UnitPrice,
      });    
    }else{
      this.getInvoiceItems.at(i).patchValue({ 
        description : '',
        unitPrice:  '',
        qty: '',
        discount: '',
        amount : '',
      });     

    }
  }
}



  
getItemList(){
  this.itemService.getAll()
 .subscribe(
    (data) => {
              this.itemList = data                
              },
   (err) => 
            {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            });  
   
 }

 

  initInvoceType() : void{
    this.quotation = {
      quotationNo: '',
      quotationDate: '',
      cusName: '',
      address: '',
      itemCode: '',
      description: '',
      unitPrice: 0.00,     
      qty: 0.00,
      discount: 0.00,
      amount: 0.00,
      total: 0.00,
      remarks: '',
      createdBy : '',
    };
  }

  initFormFields() : void{
    this.quotationForm = this.fb.group({
      quotationNo : ['',Validators.required],
      quotationDate : ['',Validators.required],
      cusName : [null,Validators.required],
      address : ['',Validators.required],
      remarks : [''],
      invoiceItems : this.fb.array([this.addInvoiceItem()]), 
       
    });

    this.autoComplete(0);
  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.isBtnDisabled = false;
    this.isShowAttachBtn=false;
    this.isHideBtn= false;
    this.isCancelBtnDisabled = true;
    this.quotationForm.reset();
    this.resetOtherControls();
    this.enableForm();
    this.getMaxId();
    this.addItemButtonClick();
    this.quotationForm.patchValue({
      quotationDate:  this.defaultDate
    });
     
   }

   getMaxId(){
    var quotationNo = 0;
    var quoNoPrefixZero  : String;
  
    this.quotationService.getMaxId()
    .subscribe(
      (res) => {
        quotationNo = Number(res[0].QuotationNo) + 1;
        quoNoPrefixZero = quotationNo.toString().padStart(6,'0');       
          this.quotationForm.patchValue({
            quotationNo : "QT" +quoNoPrefixZero
          });
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
          }, 
      )

   }
  
   addInvoiceItem() : FormGroup{
     
    return this.fb.group({
      itemCode : ['',Validators.required],
      description : ['',Validators.required],
      unitPrice :['',Validators.required],
      qty : ['',Validators.required], 
      discount :[''],
      amount : ['',Validators.required],

     });
    
   }



   get getInvoiceItems(){
      return this.quotationForm.get('invoiceItems') as FormArray;
   }

   addItemButtonClick() : void {
      this.getInvoiceItems.push(this.addInvoiceItem());
      this.autoComplete(this.getInvoiceItems.length-1);
      this.updateBillTotal();   
  }

    removeItemButtonClick(itemIndex : number) : void{
      this.getInvoiceItems.removeAt(itemIndex);
      this.filteredOptions.splice(itemIndex, 1);
      this.updateBillTotal()
    }

    resetOtherControls() : void{
        while (this.getInvoiceItems.length !== 0) {
          this.getInvoiceItems.removeAt(0);
        }

        this.quotation.total = 0.00;

    }

  
  
    calEachItemAmount(i){
      var unitPrice : number;
      let discRate :  number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.getInvoiceItems.at(i).get('itemCode').value
      if(itemCode){

      unitPrice = this.getInvoiceItems.at(i).get('unitPrice').value ? parseFloat(this.getInvoiceItems.at(i).get('unitPrice').value) :0;
      qty = this.getInvoiceItems.at(i).get('qty').value ?  parseFloat(this.getInvoiceItems.at(i).get('qty').value) : 0;
      discRate = 1- (this.getInvoiceItems.at(i).get('discount').value ? (parseFloat(this.getInvoiceItems.at(i).get('discount').value)/100) : 0)
      
      amount = parseFloat((unitPrice * qty * discRate).toFixed(2));
      this.getInvoiceItems.at(i).patchValue({amount : amount.toString() });

      }
  
      this.updateBillTotal();
    }

  updateBillTotal(){
    this.quotation.total = this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
   
  }


  mapFormValuesToModel(){
    this.quotationData =[];
    var result = [];

    for(let i=0; i < this.getInvoiceItems.length; i++){

    this.quotation.quotationNo=this.quotationForm.value.quotationNo;
    this.quotation.quotationDate=this.quotationForm.value.quotationDate;
    this.quotation.cusName=this.quotationForm.value.cusName;
    this.quotation.address = this.quotationForm.value.address;
    this.quotation.itemCode =this.getInvoiceItems.value[i].itemCode
    this.quotation.description=this.getInvoiceItems.value[i].description;
    this.quotation.unitPrice=this.getInvoiceItems.value[i].unitPrice;
    this.quotation.discount=this.getInvoiceItems.value[i].discount;
    this.quotation.qty=this.getInvoiceItems.value[i].qty;
    this.quotation.amount=this.getInvoiceItems.value[i].amount;
    this.quotation.total=this.quotation.total;
    this.quotation.remarks = this.quotationForm.value.remarks;
    this.quotation.createdBy =this.authService.getUserLoggedIn();
    
    this.quotationData.push(
      this.quotation.quotationNo,
      this.quotation.quotationDate,
      this.quotation.cusName,
      this.quotation.address,
          
      this.quotation.itemCode,
      this.quotation.description,
      this.quotation.unitPrice,
      this.quotation.qty,
      this.quotation.discount,  
      this.quotation.amount,

      this.quotation.total,
      this.quotation.remarks,
      this.quotation.createdBy,

      );

    }

    while(this.quotationData.length){
      result.push(this.quotationData.splice(0,13));
    }

    return result;

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.quotationForm,true);
    var data = this.mapFormValuesToModel();

    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;
          this.quotationService.addQuotation(data)
          .subscribe(
            (res) =>{

              if(res.success === 0){
                this.quotationForm.patchValue({
                quotationNo : res.autoId
                });
              this.saveButtonClick();
              this.showProcessingIndicator = false; 
              
              }else if(res.success === 1){
                console.log(res);
                this.toastr.success('Quotation created successfully','Success');
                this.isfieldReadOnly  = true;
                this.isBtnDisabled = true;
                this.isShowAttachBtn = true; 
                this.isHideBtn = true;
                this.isCancelBtnDisabled = false;
                this.disableForm(); 
                this.showProcessingIndicator = false; 
             }   
            
            },
            (err) =>{
              this.toastr.error('Failed to create quotation','Failure'); 
              this.showProcessingIndicator = false;   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }

   approvedButtonButtonClicked() : void{

    this.logValidationErrors(this.quotationForm,true);
    this.mapFormValuesToModel();
    var data = {
      quotationNo : this.quotation.quotationNo,
      status : 'Approved',
    };

    if(this.isFilledFromFields()){
    
          this.quotationService.updateQuotation(data)
          .subscribe(
            (res) =>{
              this.toastr.success('Quotation Approved','Success');
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isCancelBtnDisabled = false;
              this.disableForm();
                
            },
            (err) =>{
              this.toastr.error('Failed to approve quotation','Failure'); 
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
                                                                                                                                                                                                        
        } 

      

   }

   deleteButtonClick(){   
    var quotationNo = this.quotationForm.get('quotationNo').value;
    if(quotationNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this quotation?')
    .afterClosed().subscribe(res =>{
      if(res){
    const data = this.mapFormValuesToModel();  
     this.quotationService.deleteQuotation(quotationNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Quotation deleted successfully','Success');
                   this.newButtonClick();
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete quotation','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}

   enableForm():void{
    Object.keys(this.quotationForm.controls).forEach(key => {
      this.quotationForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.quotationForm.controls).forEach(key => {
      this.quotationForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.quotationForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.quotationForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.quotationForm.get('invoiceItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });


    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getInvoiceItems.length==0 || this.quotationForm.get('invoiceItems').invalid){
          return false;
          }
        return true;
  }

 



    viewQuotationById(){
        var hasQuotationNo;
        var quotationNo;

        hasQuotationNo =this.route.snapshot.queryParamMap.has('quotationNo');
         
          if(hasQuotationNo){
            quotationNo = this.route.snapshot.queryParamMap.get('quotationNo')
            this.quotationService.getQuotation(quotationNo)
            .subscribe(
              (data) => {
                        if(data){                 
                          this.isCancelBtnDisabled = false;
                          this.patchValuesToForm(data); 
                          this.isBtnDisabled = true;
                          this.isShowAttachBtn = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true;    
                          this.isHideBtn= true;                                      
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }

    }

patchValuesToForm(data){
  this.quotationForm.patchValue({  
    quotationNo : data[0].QuotationNo,
    quotationDate : moment(data[0].QuotationDate).format("YYYY-MM-DD"),
    cusName : data[0].CusName,
    address : data[0].Address,
    remarks : data[0].Remarks,

  });
  
  this.quotationForm.setControl('invoiceItems',this.setInvoiceItems(data));
  this.quotation.total = data[0].Total;

}


  setInvoiceItems(data) : FormArray{
    const invoiceItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      invoiceItemArray.push(this.fb.group({
        itemCode : [data[i].ItemCode],
        description : [data[i].Description],
        unitPrice : [data[i].UnitPrice],       
        qty : [data[i].Qty],
        discount : [data[i].Discount],
        amount : [data[i].Amount],    
      }));
    }
    return invoiceItemArray;
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.quotationForm.value.quotationNo;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }


 

     createInvoiceButtonClicked(){  
      let quotationNo = this.quotationForm.value.quotationNo;
      this.router.navigate(['../invoice'],{queryParams : {'quotationNo':quotationNo},relativeTo : this.route});            
    }


    savePDF(action){

      let remarkBox = {type: 'rect',x: 0,  y: 0,  w: 320,  h: 150,lineColor: this.quotationForm.value.remarks ? '#E5E7E9': '#FFFFFF'};                                                                                                               
     
     let remarks = this.quotationForm.value.remarks ? this.quotationForm.value.remarks.replace(/\n/g, '<br>'): ''
     let htmlRemarks = htmlToPdfmake(remarks); 


      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'portrait',     
  
        content: [ 
  
            
          {
            columns : [ 
              
                    { image:this.logo,            
                      width: 100,
                      height: 100,
                      fontSize: 28,
                      margin: [0, 0, 0, 15],
                    },

  
                   { width: '*', text: '' },
                   [                                         
                    {
                     text: 'QUOTATION',
                     color: '#333333',
                     width: 165,
                     fontSize: 30,
                     bold: true,
                     alignment: 'right',
                     margin: [0, 0, 0, 15],
                   }, 
                   { text: `Quotation No : ${this.quotationForm.value.quotationNo}`, alignment: 'right' },  
                   { text: `Quotation Date : ${moment(this.quotationForm.value.quotationDate).format("YYYY-MM-DD")}`,alignment: 'right' } 
                 ],                                                          
                        
            ]
    
          },
  
          {
            columns : [
              [
                {
                  text: this.companyData[0].CompanyName,  
                  bold: true  
                },
                { text: this.companyData[0].Address },  
                { text: this.companyData[0].Phone },  
                { text: this.companyData[0].Email }  
              ],
              [
                { text: 'Customer Details :', margin: [40, 0, 0, 0]},  
                { text: this.quotationForm.value.cusName, bold:true, margin: [40, 0, 0, 0] },  
                { text: this.quotationForm.value.address,margin: [40, 0, 0, 0] },  
  
              ],
            ]
  
          },
  
          '\n\n',
                             
          {  
            layout: {
              defaultBorder: false,
              hLineWidth: function(i, node) {
                return 1;
              },
              vLineWidth: function(i, node) {
                return 1;
              },
              hLineColor: function(i, node) {
                if (i === 1 || i === 0) {
                  return '#bfdde8';
                }
                return '#eaeaea';
              },
              vLineColor: function(i, node) {
                return '#eaeaea';
              },
              hLineStyle: function(i, node) {
                // if (i === 0 || i === node.table.body.length) {
                return null;
                //}
              },
              // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              paddingLeft: function(i, node) {
                return 10;
              },
              paddingRight: function(i, node) {
                return 10;
              },
              paddingTop: function(i, node) {
                return 2;
              },
              paddingBottom: function(i, node) {
                return 2;
              },
              fillColor: function(rowIndex, node, columnIndex) {
                return '#fff';
              },
            },
            table: {  
                headerRows: 1,  
                widths: ['*', 'auto', 'auto','auto','auto'],  
                body: [  
                  [
                   { text: 'Description',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Unit Price',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Qty',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Disc(%)',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Amount',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                  ...this.getInvoiceItems.value.map(p => ([{ text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5]}, {text : this.transformNumberFormat(p.unitPrice), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right' },{text : this.transformNumberFormat(p.qty), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right' },{text : this.transformNumberFormat(p.discount), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right' }, { text: this.transformNumberFormat(p.amount), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right' }])),               
                ]           
          }       
        },
  
        '\n',
        '\n\n',
        {
          columns : [

            {
              width : 320,
 
              columns : [
                [ 
                  
                  {text: 'Note:', margin: [0, 0, 0, 5]},
                  {canvas: [remarkBox]},
                  {
                    columns : [
                      {width : remarkBox.w, noWrap:false,maxHeight :remarkBox.h,  margin: [5, 5, 5, 5], text : htmlRemarks ? htmlRemarks: '' }
                    ],
                    relativePosition : {x : (remarkBox.x), y : -remarkBox.h}

                  }                                                                                                             
                ],
              ]

            },

            {
               width : 60, text :""
            },                          
            
            [ 
              {  
              margin: [0, 20, 0, 5],
              width : 100,            
                  layout: {
                  defaultBorder: false,
                  hLineWidth: function(i, node) {
                    return 1;
                  },
                  vLineWidth: function(i, node) {
                    return 1;
                  },
                  hLineColor: function(i, node) {
                    return '#eaeaea';
                  },
                  vLineColor: function(i, node) {
                    return '#eaeaea';
                  },
                  hLineStyle: function(i, node) {
                    // if (i === 0 || i === node.table.body.length) {
                    return null;
                    //}
                  },
                  // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                  paddingLeft: function(i, node) {
                    return 10;
                  },
                  paddingRight: function(i, node) {
                    return 10;
                  },
                  paddingTop: function(i, node) {
                    return 3;
                  },
                  paddingBottom: function(i, node) {
                    return 3;
                  },
                  fillColor: function(rowIndex, node, columnIndex) {
                    return '#fff';
                  },
                },

              table: {
                  headerRows: 1,
                  widths: ['auto', 'auto'],
                      body: [
                      [
                        {
                          text: 'Total',
                          border: [false, true, false, true],
                          alignment: 'right',
                          margin: [0, 5, 0, 5],
                        },
                        {                     
                          text: this.transformNumberFormat(this.quotation.total),
                          border: [false, true, false, true],
                          alignment: 'right',
                          fillColor: '#f5f5f5',
                          margin: [0, 5, 0, 5],
                        },
                      ],                     
                    ],
                  },
            }, 
            '\n\n',
            '\n\n',
            '\n\n',
            {
              canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 130, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]
            },
            {text: 'Signature', alignment: 'center', margin: [0, 5, 0, 5]},
         
          ]

        ]
  
        },

        '\n',

        { text:' To confirm the Booking, Pls deposit a advance payment for below mentioned company account details', italics: true,   margin: [0, 0, 0, 0]},
        '\n',
        {  
          style: 'tableExample',
          table: {    
            dontBreakRows:true,
            unbreakable: true,
              widths: ['50%', '50%'],  
              body: [  
                [
                  {text : 'ACCOUNT NAME',   margin: [0, 0, 0, 0]},  
                  { text:'Dinuda Resort (Pvt) Ltd',  margin: [0, 0, 0, 0]}              
                ],  
                [
                  { text:'BANK NAME',   margin: [0, 0, 0, 0]},
                  { text:'Sampath Bank',   margin: [0, 0, 0, 0]}
                ],   
                [
                  {text : 'BRANCH',   margin: [0, 0, 0, 0]},  
                  { text:'Kundasale Branch',  margin: [0, 0, 0, 0]}              
                ],              
                 [
                   {text : 'ACCOUNT NO.',  margin: [0, 0, 0, 0]},  
                   { text:'013310000358',   margin: [0, 0, 0, 0]}              
                 ], 
                
              ],           
        },      
      },
  
      '\n\n',             
        {
         text: 'Thank You For Your Business!',
         width: '*', 
         alignment: 'center',  
         italics: true, 
        }
  
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };
  
        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
          else if(action === 'download'){    
            pdfMake.createPdf(documentDefinition).download(`Quotation-${this.quotationForm.value.quotationNo}`);     
        }
     }
  
  
     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }


  

}
